// extracted by mini-css-extract-plugin
module.exports = {"ExternalLink":"external-link_ExternalLink__2EHnj","ExternalLinkInText":"external-link_ExternalLinkInText__X1sJw","ExternalLinkButton":"external-link_ExternalLinkButton__2qjI0"};